const features = [
  {
    title: '2026夏季新番',
    tag: '火热上线',
    desc: '夏季新番全面上线，热血、恋爱、异世界全类型覆盖，樱花动漫之家第一时间同步更新，追更动漫从现在开始。',
    img: 'https://readdy.ai/api/search-image?query=Vibrant%20anime%20collage%20summer%20season%202026%20new%20releases%20with%20colorful%20characters%20cherry%20blossoms%20warm%20golden%20lighting%20cinematic%20composition%20soft%20dreamy%20atmosphere%20sakura%20petals%20floating&width=800&height=500&seq=carousel-summer-2026&orientation=landscape',
    alt: '2026夏季新番火热上线专题',
  },
  {
    title: '热血番剧精选',
    tag: '燃到飞起',
    desc: '精选本季最燃热血番剧，战斗场面炸裂、剧情节奏紧凑，每一帧都是名场面，满足你对追更动漫的所有期待。',
    img: 'https://readdy.ai/api/search-image?query=Dynamic%20action%20anime%20illustration%20with%20intense%20battle%20scene%20vibrant%20energy%20effects%20warm%20orange%20and%20red%20tones%20dramatic%20lighting%20epic%20composition%20cinematic%20anime%20style&width=800&height=500&seq=carousel-action-anime&orientation=landscape',
    alt: '热血番剧精选专题推荐',
  },
  {
    title: '新番追更日历',
    tag: '每日更新',
    desc: '完整的新番追更日历，按周排列每日更新的番剧列表，再也不怕漏追任何一部连载动漫，追更计划一目了然。',
    img: 'https://readdy.ai/api/search-image?query=Clean%20modern%20calendar%20design%20with%20anime%20themed%20illustrations%20cherry%20blossom%20decorations%20warm%20pink%20and%20cream%20color%20palette%20soft%20lighting%20organized%20layout%20minimalist%20aesthetic&width=800&height=500&seq=carousel-calendar&orientation=landscape',
    alt: '新番追更日历专题',
  },
  {
    title: '经典动漫回顾',
    tag: '永恒经典',
    desc: '回望那些年追过的经典动漫，从神作到情怀之作，樱花动漫之家为你整理最值得重温的动漫名作合集。',
    img: 'https://readdy.ai/api/search-image?query=Nostalgic%20classic%20anime%20illustration%20with%20iconic%20characters%20silhouettes%20warm%20golden%20sunset%20lighting%20vintage%20film%20texture%20cherry%20blossom%20petals%20emotional%20atmosphere%20cinematic&width=800&height=500&seq=carousel-classic&orientation=landscape',
    alt: '经典动漫回顾专题',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            焦点推荐
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            精选热门专题与推荐内容，帮你发现最值得追的动漫
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {features.map((item, i) => (
            <a
              key={i}
              href="#ranking"
              className="group relative bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="flex flex-col sm:flex-row">
                <div className="sm:w-2/5 flex-shrink-0">
                  <div className="relative h-48 sm:h-full min-h-[200px]">
                    <img
                      src={item.img}
                      alt={item.alt}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-r from-transparent via-transparent to-background-50/50 sm:bg-gradient-to-t sm:from-transparent sm:via-transparent sm:to-transparent"></div>
                  </div>
                </div>
                <div className="flex-1 p-5 md:p-6 flex flex-col justify-center">
                  <span className="inline-block px-2.5 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3 w-fit">
                    {item.tag}
                  </span>
                  <h3 className="text-base md:text-lg font-heading text-foreground-900 mb-2 font-semibold">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3">
                    {item.desc}
                  </p>
                  <span className="inline-flex items-center gap-1 text-xs text-primary-600 font-medium mt-3 group-hover:gap-2 transition-all">
                    了解更多
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}